export default "__VITE_ASSET__7a3fe7f3__"